module.exports = __webpack_public_path__ + "img/banner_about.20360840.png";